export default "__VITE_ASSET__x5p_T9h9__"